import { add } from 'date-fns'
import Cookies from 'universal-cookie'

import type { ErrorResponse, Tokens } from '@assets/types/globals'
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { authActions } from '@store/auth/auth.slice'

const API_URL = process.env.REACT_APP_API_URL

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers) => {
    const cookies = new Cookies(null, { path: '/' })
    const token = cookies.get('accessToken')

    headers.set('Accept', 'application/json')

    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const baseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError & ErrorResponse> = async (args, api, extraOptions): Promise<any> => {
  let result = await baseQuery(args, api, extraOptions)

  if (result.error && result.error.status === 401) {
    const cookies = new Cookies(null, { path: '/' })

    cookies.remove('accessToken')

    const refresh = cookies.get('refreshToken')

    const refreshResult = await baseQuery(
      {
        url: '/token/refresh/',
        method: 'POST',
        body: { refresh },
      },
      api,
      extraOptions,
    )

    if (refreshResult.data) {
      const data = refreshResult.data as Tokens

      cookies.set('accessToken', data.access, {
        path: '/',
        expires: add(new Date(), { days: 1 }),
        // httpOnly: false,
        // domain: '.vercel.app',
      })
      cookies.set('refreshToken', data.refresh, {
        path: '/',
        expires: add(new Date(), { days: 1 }),
        // httpOnly: true,
      })

      result = await baseQuery(args, api, extraOptions)
    } else {
      api.dispatch(authActions.setAuth(false))
    }
  }
  return result
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    'signUpByParents',
    'signUpByStudent',
    'aboutMe',
    'parents',
    'teacher',
    'studentHomework',
    'studentIndividual',
    'studentTest',
    'teacherLesson',
    'teacherHWProgress',
    'teacherIndividual',
    'teacherTest',
    'todoList',
    'teacherSubjectTest',
    'teacherTopicTest',
    'hasUnread',
    'studentQuarterTest',
    'studentTopicTest',
    'teacherQuarterTest',
    'teacherQuarterTestProgress',
    'teacherQuarterTestInternal',
    'teacherTopicTest',
    'teacherTopicTestProgress',
    'teacherTopicTestInternal',
    'studentScheduleByWeekOrMonth',
    'teacherScheduleByWeekOrMonth',
    'teacherSlotsForStudent',
    'studentSlotsForTeacher',
    'teacherEventDetail',
    'individualPlanTemplates',
    'individualPlanStudents',
    'individualPlan',
    'externatSubjects',
    'externatSubject',
    'externatTest',
    'externatTutors',
    'invitationsNewUsers',
    'adminStudents',
    'adminStaff',
    'permission',
    'jobRole',
    'externatTestTotalScore',
  ],
  endpoints: () => ({}),
})
